import { useTranslation } from "react-i18next";
import { Button, Icon, Modal } from "semantic-ui-react";

import { ConnectInterventionButton } from "components/ConnectInterventionModal/components";
import "components/ConnectInterventionModal/ConnectInterventionModal.scss";

import type { TFunction } from "i18next";
import type { Appointment } from "models";

export type ConnectToInterventionPayload = {
  title: string;
  question_result_id: number;
};

type ConnectInterventionModalProps = {
  open: boolean;
  checklistName: string;
  appointment: Appointment;
  connectToInterventionPayload: ConnectToInterventionPayload | null;
  closeOnDimmerClick?: boolean;
  onClose: () => void;
};

type NotConnectedInterventionsListProps = {
  t: TFunction;
  checklistName: string;
  appointment: Appointment;
  connectToInterventionPayload: ConnectToInterventionPayload;
  onClose: () => void;
};

const NotConnectedInterventionsList = ({ t, appointment, connectToInterventionPayload, onClose, checklistName }: NotConnectedInterventionsListProps) => {
  const notConnectedInterventions = appointment.interventions?.filter(intervention => !intervention.question_result_id) ?? [];

  if (!notConnectedInterventions.length) return <span>{t("v8_no_interventions_to_connect", "There are no interventions to connect to")}</span>;

  return notConnectedInterventions.map(intervention => (
    <div key={intervention.id} className="ConnectInterventionModal__intervention">
      <span>{intervention.title}</span>
      <ConnectInterventionButton onCloseConnectModal={onClose} payload={connectToInterventionPayload} checklistName={checklistName} intervention={intervention} />
    </div>
  ));
};

export const ConnectInterventionModal = ({
  open,
  appointment,
  checklistName,
  closeOnDimmerClick,
  connectToInterventionPayload,
  onClose
}: ConnectInterventionModalProps) => {
  const { t } = useTranslation();

  if (!connectToInterventionPayload) return null;

  return (
    <Modal open={open} closeOnDimmerClick={Boolean(closeOnDimmerClick)} className="ConnectInterventionModal">
      <Modal.Header className="ConnectInterventionModal__header">
        <span>{t("v8_connect_checklist_intervention", "Connect checklist item to intervention")}</span>
        <Button className="modal-close-btn" basic onClick={onClose}>
          <Icon className="xmark grey" />
        </Button>
      </Modal.Header>

      <Modal.Content>
        <NotConnectedInterventionsList
          t={t}
          appointment={appointment}
          checklistName={checklistName}
          connectToInterventionPayload={connectToInterventionPayload}
          onClose={onClose}
        />
      </Modal.Content>
    </Modal>
  );
};
